import { useState } from "react";
import { AppLayout } from "../../layout/AppLayout";
import { motion } from "framer-motion";
import { Arrow } from "../svg/Wallet/Wallet";
import { useNavigate } from "react-router-dom";
import { BaseInput } from "../input/baseInput";
import Select from "../Select";
import { BankOutlined, Cheveron } from "../svg/worldSvgs/rmc/Achievements";
import clsx from "clsx";
import { Card } from "../Card";
import Button from "../button/Button";

const banks = [
  { label: "Bank of America", value: "boa" },
  { label: "Chase", value: "chase" },
  { label: "Wells Fargo", value: "wells-fargo" },
  { label: "Citibank", value: "citi" },
  { label: "US Bank", value: "us-bank" },
  { label: "TD Bank", value: "td-bank" },
];

export const PaymentDetails = () => {
  const navigate = useNavigate();
  const [bank, setBank] = useState({});
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="pt-10 pb-7 px-5 min-h-screen flex flex-col">
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="w-full relative flex flex-col flex-grow"
        >
          <div className="relative flex items-center justify-center mb-10">
            <Arrow
              onClick={() => navigate(-1)}
              stroke="#fff"
              className="text-lg absolute left-0 cursor-pointer"
            />
            <p className="font-bold text-xl text-black">Payment Details</p>
          </div>
          <Card>
            <BaseInput
              label="Account number"
              type="number"
              placeholder="Enter 10 digits Account number"
              inputClass="bg-[#F8F8F8]"
              className="mb-5"
            />

            <Select
              leadingIcon={
                <div className="mr-3">
                  <BankOutlined bgFill="#ECECEC80" fill="#B4B4B4" />{" "}
                </div>
              }
              trailingIcon={
                <Cheveron stroke="#00000080" className="rotate-90" />
              }
              options={banks}
              selected={bank}
              setSelected={setBank}
              label="Bank name"
              placeholder="Select Bank"
              cheveronClass="!text-[#00000080]"
              selectedOptionClass="bg-[#2741D6] !text-white"
              className="mb-5"
              labelClass="text-primary-black"
              selectedClass={clsx(
                "base_select_selected !bg-[#F8F8F8] !rounded-[50px]",
                bank?.value ? "text-primary-black" : "!text-[#00000080]"
              )}
              dropdownClass="base_select_dropdown !bg-white !shadow-lg "
              optionsClass="base_select_options !text-primary-black hover:!bg-[#2741D6] hover:!text-white"
            />

            <BaseInput
              label="Account name"
              placeholder="Account name"
              inputClass="bg-[#F8F8F8]"
            />
          </Card>
          <Button
            onClick={() => {}}
            text="Save"
            className="!py-4 !mt-7 !rounded-[50px]"
          />
        </motion.div>
      </div>
    </AppLayout>
  );
};
